import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import WebviewManager from './components/WebviewManager';
import { useAlerts } from './hooks/useAlerts';
import './App.css';

// Initial state for 4 distinct accounts
const INITIAL_ACCOUNTS = [
  { id: 'acc1', name: 'Personal MAX', email: 'user@personal.com', unread: 0, status: 'online' },
  { id: 'acc2', name: 'Work Account', email: 'dev@company.com', unread: 3, status: 'online' },
  { id: 'acc3', name: 'Project Alpha', email: 'alpha@team.org', unread: 0, status: 'away' },
  { id: 'acc4', name: 'Support Desk', email: 'help@service.net', unread: 12, status: 'online' },
];

function App() {
  const [accounts, setAccounts] = useState(INITIAL_ACCOUNTS);
  const [activeId, setActiveId] = useState(INITIAL_ACCOUNTS[0].id);
  const { triggerAlert } = useAlerts();

  // Simulate incoming messages and local notifications
  useEffect(() => {
    const interval = setInterval(() => {
      setAccounts(prevAccounts => {
        const newAccounts = [...prevAccounts];
        // Randomly pick an account to receive a message (10% chance per tick)
        if (Math.random() > 0.9) {
          const randomIndex = Math.floor(Math.random() * newAccounts.length);
          newAccounts[randomIndex] = {
            ...newAccounts[randomIndex],
            unread: newAccounts[randomIndex].unread + 1
          };
          
          // Trigger local desktop notification if it's not the active account
          if (newAccounts[randomIndex].id !== activeId) {
             triggerAlert(`New message in ${newAccounts[randomIndex].name}`, {
               body: 'You have unread messages waiting.',
             });
          }
        }
        return newAccounts;
      });
    }, 5000); // Check every 5 seconds

    return () => clearInterval(interval);
  }, [activeId, triggerAlert]);

  const activeAccount = accounts.find(a => a.id === activeId) || accounts[0];

  return (
    <div className="flex h-screen w-full bg-gray-950 overflow-hidden font-sans text-gray-100 selection:bg-blue-500/30">
      <Sidebar 
        accounts={accounts} 
        activeId={activeId} 
        onSelectAccount={setActiveId} 
      />
      
      <div className="flex-1 flex flex-col min-w-0 h-full relative shadow-[-10px_0_30px_rgba(0,0,0,0.5)] z-10">
        <TopBar activeAccount={activeAccount} />
        <WebviewManager accounts={accounts} activeId={activeId} />
      </div>
    </div>
  );
}

export default App;